import React, { ButtonHTMLAttributes } from 'react';

type buttonVariant = 'primary' | 'secondary';

const buttonVariantClasses: Record<buttonVariant, string> = {
  primary: 'bg-primary text-white',
  secondary: 'border-[2px] border-shadow-4 text-black',
};
interface ButtonProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'dangerouslySetInnerHTML'
  > {
  className?: string;
  label: string;
  variant?: buttonVariant;
  image?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  variant = 'primary',
  image,
  className,
  ...rest
}) => {
  return (
    <button
      className={`rounded-[20px] 2xl:w-fit 2xl:flex-1 font-bold ${
        !!image && 'px-5 w-full py-2 text-[16px]'
      } ${className} ${buttonVariantClasses[variant]}`}
      {...rest}>
      {!!image && (
        <img
          src={image}
          alt="btnimg"
          className={`w-[30px] absolute ${className}`}
        />
      )}
      {label}
    </button>
  );
};

export default Button;
